import { formatDate } from '@angular/common';

export enum FileType {
  PDF   = 'application/pdf',
  EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
}

export class FileUtils {

  static saveAndOpenFile(file: Blob, fileType: FileType, fileName: string, createdAt?: string, openFile: boolean = true): void {
    const date: string = createdAt ? formatDate(new Date().toDateString(), 'dd-MM-yyyy', 'en') : '';

    const newBlob: Blob = new Blob([file], {type: fileType});
    const fileUrl: string = window.URL.createObjectURL(newBlob);
    const nFileName: string = createdAt ? `${fileName}_${date}` : `${fileName}`;

    const fileLink: HTMLAnchorElement = document.createElement('a');
    fileLink.href = fileUrl;
    fileLink.download = nFileName;
    fileLink.click();

    if (openFile) {
      const openNewTab: Window | null = window.open(fileLink.href, '_blank');
      if (openNewTab) {
        openNewTab.focus();
      }
    }

    window.URL.revokeObjectURL(fileUrl);
  }

  static openFile(file: Blob, fileType: FileType): void {
    const newBlob: Blob = new Blob([file], {type: fileType});
    const fileUrl: string = window.URL.createObjectURL(newBlob);

    const fileLink: HTMLAnchorElement = document.createElement('a');
    fileLink.href = fileUrl;

    const openNewTab: Window | null = window.open(fileLink.href, '_blank');
    if (openNewTab) {
      openNewTab.focus();
    }

    window.URL.revokeObjectURL(fileUrl);
  }

  static extractFilenameFromContentDisposition(contentDispositionHeader: string, defaultFilename: string): string {
    const filenameRegex: RegExp = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches: RegExpExecArray | null = filenameRegex.exec(contentDispositionHeader);
    return matches?.[1]?.replace(/['"]/g, '') ?? defaultFilename;
  }
}
